module.exports = __webpack_public_path__ + "images/titanfall_rgba(0,0,0,0.7).72b1713b6604c26b7b6875dffb0ef746.jpg";